// store/modules/state.user.js
import router from '../../router'

const state = {
  isAuthenticated: localStorage.getItem('accessToken') || false,
  accessToken: localStorage.getItem('accessToken') || null,
  refreshToken: localStorage.getItem('refreshToken') || null,
  user: JSON.parse(localStorage.getItem('userData') || 'null')
}

const getters = {
  isAuthenticated: state => !!state.accessToken,
  user: state => state.user,
  accessToken: state => state.accessToken
}

const mutations = {
  SET_AUTHENTICATED (state, accessToken) {
    state.accessToken = accessToken
    localStorage.setItem('accessToken', accessToken)
  },
  SET_TOKENS(state, { accessToken, refreshToken }) {
    state.accessToken = accessToken
    state.refreshToken = refreshToken
    localStorage.setItem('accessToken', accessToken)
    localStorage.setItem('refreshToken', refreshToken)
  },
  
  SET_USER(state, userData) {
    state.user = userData
    localStorage.setItem('userData', JSON.stringify(userData))
  },
  
  LOGOUT(state) {
    state.accessToken = null
    state.refreshToken = null
    state.user = null
    localStorage.removeItem('accessToken')
    localStorage.removeItem('refreshToken')
    localStorage.removeItem('userData')
  }
}

const actions = {
  login({ commit }, { accessToken, refreshToken, user }) {
    commit('SET_TOKENS', { accessToken, refreshToken })
    commit('SET_USER', user)
  },
  
  authenticate ({commit}, accessToken) {
    commit('SET_AUTHENTICATED', accessToken)
  },

  logout({ commit }) {
    commit('LOGOUT')
    router.push({ name: 'home' })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}